/* Responsive photo markup (2026-10-02 perf preview). Shared by app.js, gallery.js and custom.js.
   window.NOMARI_IMG (img-manifest.js, generated by scripts/perf/make-responsive-2026-10-02.py) = {"img/name": [w, h, [variant widths]]}.
   Variants are proportional resizes of the original (img/name-600w / -1200w; pattern tiles img/tile-*-320w), WebP with a JPG fallback.
   NomariImg.picture(src, alt, {sizes, eager, lazy:false, defer, attrs}) → '<picture>…</picture>'
     sizes : the sizes attribute (CSS width the photo is shown at); default "100vw"
     eager : first/LCP photo → fetchpriority="high", no loading=lazy
     defer : offscreen slider slide → URLs parked in data-src / data-srcset until NomariImg.hydrate(el) (gallery.js calls it on interaction)
     near  : below-the-fold photo → URLs parked the same way and loaded by one IntersectionObserver when it comes within ~300px of the
             viewport (native loading=lazy starts 1250–2500px early, which loads most of a phone page up front). Call NomariImg.watch(root)
             after inserting the markup.
   Images not in the manifest keep the old single-URL markup. */
(function(){
  "use strict";
  var C = window.NOMARI_CONFIG || {}, M = window.NOMARI_IMG || {};
  function url(src, ext){ return C.assetUrl ? C.assetUrl(src, ext) : src + ext; }
  function esc(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }
  function srcset(src, ext){
    var m = M[src]; if (!m || !m[2] || !m[2].length) return "";
    var out = m[2].map(function(w){ return url(src + "-" + w + "w", ext) + " " + w + "w"; });
    if (m[0] > m[2][m[2].length - 1]) out.push(url(src, ext) + " " + m[0] + "w");
    return out.join(", ");
  }
  function picture(src, alt, o){
    o = o || {};
    var m = M[src], sz = esc(o.sizes || "100vw"), d = (o.defer || o.near) ? "data-" : "";
    var ws = srcset(src, ".webp"), js = srcset(src, ".jpg");
    var fallback = m && m[2] && m[2].length ? url(src + "-" + m[2][0] + "w", ".jpg") : url(src, ".jpg");
    var load = o.eager ? ' fetchpriority="high"' : (o.lazy === false ? "" : ' loading="lazy"');
    return '<picture><source type="image/webp" ' + d + 'srcset="' + esc(ws || url(src, ".webp")) + '"' + (ws ? ' sizes="' + sz + '"' : "") + '>' +
      '<img ' + d + 'src="' + esc(fallback) + '"' + (js ? " " + d + 'srcset="' + esc(js) + '" sizes="' + sz + '"' : "") +
      (m ? ' width="' + m[0] + '" height="' + m[1] + '"' : "") + ' alt="' + esc(alt || "") + '"' + load + ' decoding="async"' + (o.near ? " data-near" : "") + (o.attrs ? " " + o.attrs : "") + "></picture>";
  }
  // move parked data-src / data-srcset URLs into place (deferred slider slides)
  function hydrate(el){
    if (!el) return;
    Array.prototype.forEach.call(el.querySelectorAll("[data-srcset],[data-src]"), function(n){
      if (n.hasAttribute("data-srcset")){ n.setAttribute("srcset", n.getAttribute("data-srcset")); n.removeAttribute("data-srcset"); }
      if (n.hasAttribute("data-src")){ n.setAttribute("src", n.getAttribute("data-src")); n.removeAttribute("data-src"); }
    });
  }
  var io = null;
  function watch(root){
    var imgs = (root || document).querySelectorAll("img[data-near]");
    if (!imgs.length) return;
    if (!("IntersectionObserver" in window)){ Array.prototype.forEach.call(imgs, function(i){ i.removeAttribute("data-near"); hydrate(i.parentNode); }); return; }
    if (!io) io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (!e.isIntersecting) return; io.unobserve(e.target); e.target.removeAttribute("data-near"); hydrate(e.target.parentNode); }); }, {rootMargin: "300px 0px"});
    Array.prototype.forEach.call(imgs, function(i){ io.observe(i); });
  }
  window.NomariImg = { picture: picture, hydrate: hydrate, watch: watch, srcset: srcset, size: function(src){ return M[src] || null; } };
})();
